import axios from 'axios'
import ElementUI from 'element-ui'

const http = axios.create({
  timeout: 20000,
  baseURL: process.env.BASE_FRONT_URL
})

// 请求拦截
http.interceptors.request.use(config => {
  if (localStorage.getItem('token')) {
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
  }
  config.headers['Content-Type'] = 'application/json'
  return config
}, error => {
  Promise.reject(error)
})

http.interceptors.response.use(
    response => {
      if (!response.data.status) {
        return response;
      }
      return response.data;
    },
    error => {
      if (!error["response"]) {
        return Promise.reject(error);
      }
      let message = error.response.data.message;
      switch (error.response.status) {
        case 422:
          let errors = error.response.data.errors;
          let key = Object.keys(errors)[0];
          let errmsg = errors[key][0];
          Notification.error(errmsg);
          break;
        case 401:
          // to re-login
          console.log(message);
          MessageBox.confirm("登录信息失效, 请重新登录", "重新登录", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
          });
          break;
        case 403:
          Notification.error(message || "您没有此操作权限");
          break;
        default:
          Notification.error(message || "系统异常，请稍后再试");
      }
      return Promise.reject(error);
    }
);

export default http



// WEBPACK FOOTER //
// ./src/api/config.js